import { render, staticRenderFns } from "./NameListItem.vue?vue&type=template&id=4806e0e7&scoped=true&lang=pug"
import script from "./NameListItem.vue?vue&type=script&lang=js"
export * from "./NameListItem.vue?vue&type=script&lang=js"
import style0 from "./NameListItem.vue?vue&type=style&index=0&id=4806e0e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806e0e7",
  null
  
)

export default component.exports